import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {BaseActionService} from '../../service/v2/service/action/baseAction.service';
import {IWithPermissionModel} from '../../../common/permission/api/entity/iWithPermission.model';
import {BaseView} from '../../view/base.view';
import {ErrorMessageResolver} from "../../error/errorMessage.resolver";

@Component({
  selector: 'app-action-service-container',
  templateUrl: './action-service-container.component.html',
  styles: [
  ]
})
export class ActionServiceContainerComponent<Payload> extends BaseView implements OnInit, OnChanges {

  @Input() displayLoading = true;
  @Input() actionSuccessMessage: string;
  @Input() actionErrorMessage: string;
  @Input() service: BaseActionService<Payload, any>;
  @Input() buildPayload: (entity: IWithPermissionModel) => Payload;
  @Input() entity: IWithPermissionModel;
  @Input() permission: string;
  @Input() hideIfNoPermission = false;
  @Input() executeActionOnInit = false;

  @Output() actionErrorEvent: EventEmitter<any> = new EventEmitter();
  @Output() actionSuccessEvent: EventEmitter<any> = new EventEmitter();
  @Output() actionLoadingEvent: EventEmitter<boolean> = new EventEmitter();

  loading = false;
  error = undefined;
  hide = false;
  constructor(private errorMessageResolver: ErrorMessageResolver) {
    super();
  }

  ngOnInit(): void {
    if (this.executeActionOnInit && ! this.hide) {
      this.executeAction();
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['entity'] || changes['permission']) {
      this.hide = false;
      if (this.permission) {
        if (! this.entity || this.entity.permissions.permissions.indexOf(this.permission) === -1) {
          this.hide = this.hideIfNoPermission;
        }
      }
    }
  }

  executeAction() {
    this.loading = true;
    this.error = undefined;
    this.actionLoadingEvent.emit(this.loading);
    this.service.executeAction(this.buildPayload(this.entity))
        .then((result) => {
          if (this.actionSuccessMessage) {
            this.toastControl.presentConfirmation(this.actionSuccessMessage);
          }
          this.actionSuccessEvent?.emit(result);
        })
        .catch((e) => {
          this.error = e;
          const errorMessage = this.errorMessageResolver.resolveError(e);
          console.error(errorMessage);
          if (errorMessage === this.errorMessageResolver.defaultMessage) {
            this.toastControl.presentError(e, this.actionErrorMessage);
          } else {
            this.toastControl.presentError(e);
          }
          this.actionErrorEvent.emit(e);
        })
        .finally(() => {
          this.loading = false;
          this.actionLoadingEvent.emit(this.loading);
        });
  }

}
